import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { handleChange } from 'lib/stores/formStore';
import ValidationStore, { removeValidation } from 'lib/stores/validationStore';
import { formatIdFromName } from 'lib/utility';
import withValidations from 'lib/hocs/withValidations';
import useFormField from 'lib/hooks/useFormField';

const FormRadio = ({ label, name, options, disabled, childrenElements, required, showChildrenOn = 'true' }) => {
  const [value] = useFormField(name);

  useEffect(() => {
    if (typeof showChildrenOn === 'object' && showChildrenOn.includes(value)) return;
    if (typeof showChildrenOn === 'string' && value === showChildrenOn) return;
    if (typeof childrenElements === 'undefined') return;

    childrenElements.forEach(element => {
      ValidationStore.update(s => removeValidation(s, element));

      handleChange('', element);
    });
  }, [value]);

  return (
    <div className="mb-3">
      <fieldset>
        <legend className="form-label fs-6 fw-bold d-block">
          {required && '* '}
          <FormattedMessage {...label} />
        </legend>
        <div className="d-flex">
          {options.map(([option, optionLabel]) => (
            <div className="form-check me-3" key={optionLabel}>
              <input
                className="form-check-input"
                type="radio"
                name={name}
                id={`${formatIdFromName(name)}_${option}`}
                data-testid={`${formatIdFromName(name)}_${typeof option === 'boolean' ? option : option.split(' ').join('')}`}
                value={option}
                onChange={handleChange}
                checked={option.toString() === value.toString()}
                required={required}
                disabled={disabled}
              />
              <label className="form-check-label" htmlFor={`${formatIdFromName(name)}_${option}`}>
                {optionLabel}
              </label>
            </div>
          ))}
        </div>
      </fieldset>
    </div>
  );
};

export default withValidations({ required: true })(FormRadio);
